/**
 * The daily challenge: everyone gets the same road, trotro and random seed on a given Accra day, with its own
 * leaderboard. Worked out from the date alone, so the game and the server agree without talking to each other.
 */
export const CHALLENGE_ROUTES = ['madina-accra', 'circle-airport', 'kasoa-accra', 'kasoa-madina'] as const;

/** The big buses come up twice as often as the 4-seat Vitz, which is a harder day. */
export const CHALLENGE_VEHICLES = ['sprinter', 'hiace', 'sprinter', 'hiace', 'vitz'] as const;

export interface DailyChallenge {
  /** Accra date, e.g. "2026-10-01". */
  day: string;
  seed: number;
  route: (typeof CHALLENGE_ROUTES)[number];
  vehicle: (typeof CHALLENGE_VEHICLES)[number];
}

/** Accra is on GMT all year, so the UTC date is the Accra date. */
export function accraDay(now: number): string {
  return new Date(now).toISOString().slice(0, 10);
}

/** FNV-1a: a small, stable hash (not for security). */
function hash(text: string): number {
  let h = 0x811c9dc5;
  for (let i = 0; i < text.length; i += 1) {
    h ^= text.charCodeAt(i);
    h = Math.imul(h, 0x01000193) >>> 0;
  }
  return h >>> 0;
}

export function dailyChallenge(day: string): DailyChallenge {
  const seed = hash(`trotro-run:${day}`) & 0x7fffffff;
  return {
    day,
    seed,
    route: CHALLENGE_ROUTES[hash(`route:${day}`) % CHALLENGE_ROUTES.length] ?? CHALLENGE_ROUTES[0],
    vehicle: CHALLENGE_VEHICLES[hash(`vehicle:${day}`) % CHALLENGE_VEHICLES.length] ?? CHALLENGE_VEHICLES[0],
  };
}
